import React from 'react';

import { Asset } from '~modules/media-library/model/Asset';

interface WizardSidebarProps {
  asset: Asset;
}

const WizardSidebar: React.FC<WizardSidebarProps> = ({ asset }: WizardSidebarProps) => {
  const { previews, attributes } = asset;

  return (
    <div className="w-1/3 sticky border-solid border-0 border-l border-silver pl-3 pt-2">
      <img className="max-w-12" src={previews.details} alt="" />
      <h5>
        {attributes.title} <span>({attributes.filesizeFormatted})</span>
      </h5>
    </div>
  );
};

export default WizardSidebar;
